export const ROUTES = {
  ONBOARDING: '/onboarding',
  LOGIN: '/login',
  FNO_ONBOARDING: '/onboarding/futures-and-options',
  ACCOUNT_AGGREGATOR: '/account-aggregator',
  GROWW_HOME_PAGE: '/stocks/user/explore',
  COSMOS: '/onboarding/cosmos',
  RESET_JOURNEY: '/onboarding/reset-journey',
  ENTER_PIN: '/login/enter',
  TERMIAL_LAYOUT: '/terminal/layout',
  FNO_EXPLORE_PAGE: '/futures-and-options/user/explore',
  PROFILE_PAGE: '/user/profile/basic-details',
  MF_EXPLORE_PAGE: '/mutual-funds/user/explore'
};
